import React, { FC, useCallback, useMemo } from 'react';
import { useParams } from 'react-router';

import { DropDownOptions } from 'devextreme-react/lookup';

import { AppFieldBox } from 'components/appComponents';
import { TagBox } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';

import { EmployeeItem } from 'bus/employee/types';

type EmployeeProps = {
  value: Array<number>;
  readOnly: boolean;
  disabled: boolean;
  onChange: (value: any, selectedEmployees?: EmployeeItem[]) => void;
};

const Employee: FC<EmployeeProps> = ({ value, readOnly, onChange, disabled }) => {
  let { id } = useParams<{ id: string }>();

  const storeEmployee: any = useMemo(() => {
    const defaultFilter = [['postId', '=', 1], 'and', ['status', '=', 0]];

    return $createDataSource('/v1/employee', 'id', { defaultFilter });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // Мемоизируем функцию обработки изменения значения
  const handleValueChanged = useCallback(
    (e: any) => {
      // Получаем данные о выбранных водителях
      const selectedEmployees =
        e.value
          ?.map((id: number) => storeEmployee.items().find((item: EmployeeItem) => item.id === id))
          .filter(Boolean) || [];
      onChange(e.value, selectedEmployees);
    },
    [onChange, storeEmployee],
  );

  // Мемоизируем пропсы для DropDownOptions
  const dropDownOptionsProps = useMemo(
    () => ({
      title: 'Выберите водителя',
      closeOnOutsideClick: true,
      showTitle: true,
    }),
    [],
  );

  return (
    <AppFieldBox label="Водитель" labelTop>
      <TagBox
        stylingMode="underlined"
        dataSource={storeEmployee}
        displayExpr="fullName"
        valueExpr="id"
        showSelectionControls
        readOnly={readOnly}
        disabled={disabled}
        showClearButton
        searchEnabled
        defaultValue={value}
        onValueChanged={handleValueChanged}
        maxDisplayedTags={2}
      >
        <DropDownOptions {...dropDownOptionsProps} />
      </TagBox>
    </AppFieldBox>
  );
};

export default React.memo(Employee);
